import { AmbienteEnum } from "./ambiente-enum";

export class AmbienteUtils {

  static ambienteEnum = AmbienteEnum;

  public static getAmbiente(): string {
    return window.location.host.split('.', 2)[1];
  }

  public static getHostName(): string {
    return window.location.host.split('.', 1)[0].toLowerCase();
  }

  public static isAmbienteProducaoDiferenteHomologacao(): boolean {
    return this.getAmbiente() == this.ambienteEnum.OXY && !this.getHostName().includes('homologacao');
  }

  public static isAmbienteTeste(): boolean {
    const ambiente: String = this.getAmbiente();
    const tenant: String = this.getHostName();
    const parametrosDefinidos = (ambiente ?? false) && (tenant ?? false);

    return parametrosDefinidos && (ambiente.toLowerCase() != this.ambienteEnum.OXY || tenant.toLowerCase() == 'homologacao');
  }
}
